module.exports = __webpack_public_path__ + "static/media/microservicios.d4e8e01e.jpg";